<template>
	<Row class="page-container-row">
		<Col
			class="width-limit-page-col"
			:span="24"
			:offset="0"
			:lg="{ span: 18, offset: 3 }"
			:xl="{ span: 12, offset: 6 }"
		>
			<VerticalLayout>
				<PageContainer :withCloseButton="false">
					<div class="home-header">
						<img
							v-if="themeLogo"
							:src="themeLogo"
							alt=""
							class="home-theme-logo"
						/>
						<TypographyTitle :level="2">{{ $t(homeHeaderKey) }}</TypographyTitle>
						<p>{{ $t('home-public.text') }}</p>
					</div>
				</PageContainer>
				<PageContainer :withCloseButton="false">
					<LoginForm />
				</PageContainer>
			</VerticalLayout>
		</Col>
	</Row>
</template>

<script lang="ts">
import { computed } from 'vue';
import { Row, Col, TypographyTitle } from 'ant-design-vue';

import { appliedThemeCaptionKey, appliedThemeLogo } from '@/api/uiThemes';

import PageContainer from '@/components/common/PageContainer.vue';
import VerticalLayout from '@/components/common/VerticalLayout.vue';
import LoginForm from '@/components/login/LoginForm.vue';


export default {
	components: {
		Row, Col, TypographyTitle, PageContainer, VerticalLayout, LoginForm,
	},
	setup() {
		const themeLogo = computed(() => appliedThemeLogo.value);
		const homeHeaderKey = computed(() => appliedThemeCaptionKey.value ?? 'home-public.header');
		return {
			themeLogo,
			homeHeaderKey,
		};
	},
};
</script>

<style scoped>
.home-header {
	text-align: center;
}

.home-header :deep(.ant-typography) {
	text-align: center;
}

.home-theme-logo {
	display: block;
	height: 56px;
	margin: 0 auto 16px;
	object-fit: contain;
}
</style>
